import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

// Componentes
import { Breadcrumb } from "../../components/Common";
import HelpAccordion from "./components/HelpAccordion";

// Dados
import { HELP_CATEGORIES } from "./constants/helpData";

const HelpCenter = () => {
    // meta title
    document.title = "Central de Ajuda | NeoApp";

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Central de Ajuda" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="mt-3">
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody className="p-4">
                                <div className="mb-4 pb-2 border-bottom">
                                    <h4 className="card-title mb-2">Base de Conhecimento e Fluxos</h4>
                                    <p className="text-muted font-size-13 mb-0">
                                        Abaixo você encontra a documentação detalhada sobre os principais fluxos sistêmicos do NeoApp e o passo-a-passo sugerido, divididos por área.
                                    </p>
                                </div>

                                {HELP_CATEGORIES.map(category => (
                                    <HelpAccordion key={category.id} category={category} />
                                ))}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default HelpCenter;
